export default {
    "colors": [],
    "homepage_settings": {
        "tabsVisible": false,
        "tabsPosition": "top"
    },
    "widgets": {
        "button": {
            "showName": "Кнопка",
            "widgetFolder": "components/home/dashboard/widgets/ButtonWidget"
        },
        "text": {
            "showName": "Текст",
            "widgetFolder": "components/home/dashboard/widgets/TextWidget"
        },
        "vqb_table": {
            "showName": "Таблица",
            "widgetFolder": "components/home/dashboard/widgets/VQBTableWidget"
        },
        "vqb_cell": {
            "showName": "Ячейка",
            "widgetFolder": "components/home/dashboard/widgets/VQBCellWidget"
        },
        "vqb_chart": {
            "showName": "График",
            "widgetFolder": "components/home/dashboard/widgets/VQBChartWidget"
        },
        "one_to_one_meetings": {
            "showName": "Встречи 1:1 — расписание",
            "description": "Список предстоящих встреч 1:1",
            "icon": "fa-calendar-alt",
            "widgetFolder": "components/home/dashboard/widgets/OneToOneMeetingsWidget"
        },
        "one_to_one_agreements": {
            "showName": "Встречи 1:1 — договорённости",
            "description": "Список договорённостей из встреч 1:1",
            "icon": "fa-clipboard-check",
            "widgetFolder": "components/home/dashboard/widgets/OneToOneAgreementsWidget"
        }
    }
}